import React from 'react';

/**
 * In case of we need to style it or adapt it later
 * in this way, we can impact all star in one time
 */
export const RequiredStar = () => {
  return <span aria-hidden="true">*</span>;
};
